/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { ContactUsParameter, sendContactInfo } from "@eisinc/App/Services/ContactUsService";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface ContactUsHandlerParameter {
    formData?: any;
    onSuccess?: (error: string) => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<ContactUsHandlerParameter, ContactUsParameter, ServiceResult<any>>;

export const DispatchBeginSendingInfo: HandlerType = props => {
    props.dispatch({
        type: "ContactUs/BeginSendingContactInformation",
        isLoading: true,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestQuote: HandlerType = async props => {
    props.apiResult = await sendContactInfo(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result!);
    }
};

export const DispatchCompletedSendingInfo: HandlerType = props => {
    props.dispatch({
        type: "ContactUs/CompletedSendingContactInformation",
        isLoading: false,
    } as any);
};

export const chain = [
    DispatchBeginSendingInfo,
    PopulateApiParameter,
    RequestQuote,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    DispatchCompletedSendingInfo,
];

const sendContactInfoHandler = createHandlerChainRunner(chain, "sendContactInfoHandler");
export default sendContactInfoHandler;
